import { PrivateAPINamespace } from '../PrivateAPINamespace';
import type {
  FontPickerOptions,
  FontPickerOnStyleChange,
  OnFontChanged,
} from '@wix/editor-platform-sdk-types';

export class InputsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'inputs';

  openLinkPanel: typeof this.ps.hostAPI.editor.openLinkPanel = (options) => {
    return this.ps.hostAPI.editor.openLinkPanel(options);
  };

  openMediaPanel: typeof this.ps.hostAPI.editor.openMediaPanel = (options) => {
    return this.ps.hostAPI.editor.openMediaPanel(options);
  };

  openColorPicker: typeof this.ps.hostAPI.editor.openColorPicker = (
    options,
    onColorChange,
  ) => {
    return this.ps.hostAPI.editor.openColorPicker(options, onColorChange);
  };

  openFontPicker = (
    options: FontPickerOptions,
    onFontChange: FontPickerOnStyleChange,
  ) => {
    return this.ps.hostAPI.editor.openFontPicker(options, onFontChange);
  };
  openFontPickerV2 = (
    options: FontPickerOptions,
    onFontChanged: OnFontChanged,
  ) => {
    return this.ps.hostAPI.editor.openFontPicker(
      options,
      () => {},
      onFontChanged,
    );
  };
}
